import "./ai-boost-setup";
import "./legal-toc";

import.meta.glob(["../images/**"], { eager: true, query: "?url", import: "default" });

// Simple RudderStack Event Tracking Function
window.trackEvent = function (eventName, properties = {}) {
    if (window.rudderanalytics && typeof window.rudderanalytics.track === "function") {
        try {
            window.rudderanalytics.track(eventName, properties);
        } catch (error) {
            console.error("RudderStack tracking error:", error);
        }
    }
};
